var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightAngularArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65986 9.83133L1.97201 17.6556C1.75537 17.8761 1.46155 18 1.15518 18C0.848805 18 0.554981 17.8761 0.338344 17.6556C0.121706 17.4352 2.28265e-09 17.1361 0 16.8243C-2.28265e-09 16.5125 0.121706 16.2135 0.338344 15.993L7.21032 9.00098L0.340266 2.00702C0.232998 1.89784 0.147908 1.76824 0.0898545 1.6256C0.0318013 1.48296 0.00192164 1.33008 0.00192164 1.17568C0.00192164 1.02129 0.0318013 0.868409 0.0898545 0.725769C0.147908 0.583128 0.232998 0.453522 0.340266 0.34435C0.447534 0.235178 0.57488 0.148577 0.715033 0.0894937C0.855185 0.0304101 1.0054 -1.15032e-09 1.1571 0C1.3088 1.15032e-09 1.45901 0.0304101 1.59917 0.0894937C1.73932 0.148577 1.86667 0.235178 1.97393 0.34435L9.66179 8.16867C9.76917 8.27783 9.85432 8.40749 9.91236 8.55022C9.97039 8.69295 10.0002 8.84594 10 9.00041C9.99982 9.15487 9.96968 9.30779 9.91131 9.45038C9.85295 9.59297 9.7675 9.72243 9.65986 9.83133Z",
    fill: "#19191C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAngularArrow);
export default __webpack_public_path__ + "static/media/right-angular-arrow.dd8b09d0239b20a2004ad883ff4e97da.svg";
export { ForwardRef as ReactComponent };